export const GET_ALL_VARIANT_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_ALL_VARIANT_FAILURE = "GET_CUSTOMERS_FAILURE";
export const GET_ALL_VARIANT_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const CREATE_VARIANT_REQUEST = "GET_CUSTOMERS_REQUEST";
export const CREATE_VARIANT_FAILURE = "GET_CUSTOMERS_FAILURE";
export const CREATE_VARIANT_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const UPDATE_VARIANT_REQUEST = "GET_CUSTOMERS_REQUEST";
export const UPDATE_VARIANT_FAILURE = "GET_CUSTOMERS_FAILURE";
export const UPDATE_VARIANT_SUCCESS = "GET_CUSTOMERS_SUCCESS";

export const DELETE_VARIANT_REQUEST = "GET_CUSTOMERS_REQUEST";
export const DELETE_VARIANT_FAILURE = "GET_CUSTOMERS_FAILURE";
export const DELETE_VARIANT_SUCCESS = "GET_CUSTOMERS_SUCCESS";